import React from 'react';
import { Link } from 'react-router-dom';
import ProjectItem from '../../../../components/ProjectItem/ProjectItem';
import ProjectItem1 from '../../../../components/ProjectItem/ProjectItem1';

const ProjectsArea = () => {
   return (
      <>
         <div className="tp-prjects-area pt-20 pb-120">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="tp-prjects-tab-menu mb-60">
                        <ul className="nav justify-content-center" id="myTab" role="tablist">
                           <li className="nav-item" role="presentation">
                              <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">All</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">North</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">East</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab1" data-bs-toggle="tab" data-bs-target="#contact1" type="button" role="tab" aria-controls="contact1" aria-selected="false">South</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab2" data-bs-toggle="tab" data-bs-target="#contact2" type="button" role="tab" aria-controls="contact2" aria-selected="false">West</button>
                           </li>                           
                        </ul>
                     </div>
                  </div>
               </div>
               <div className="row pb-50">
                  <div className="col-12">
                     <div className="tp-prjects-tab-content">
                        <div className="tab-content" id="myTabContent">
                           <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                              <div className="row">   

                                 <ProjectItem project_img_num="/north/Amit Arora.png" project_subtitle="Amit Arora"
                                    project_title="Chase Fly"></ProjectItem>                              

                                 <ProjectItem project_img_num="/north/vk.jpeg" project_subtitle="Vaibhav Kulshreshta"
                                    project_title="My Mudra Fincorp Pvt Ltd, Delhi"></ProjectItem>

                                 <ProjectItem project_img_num="/north/cs.jpg" project_subtitle="Chetan Sethi"
                                    project_title="Dream Inc, Delhi"></ProjectItem>

                                 <ProjectItem project_img_num="/north/SidharthGupta.png" project_subtitle="Sidharth Gupta"
                                    project_title="S and I Enterprises, Delhi"></ProjectItem>

                                  <ProjectItem project_img_num="/south/TAPAN KUMAR OJHA.png" project_subtitle="Tapan Kumar Ojha"
                                    project_title="Finnest Tahera Financial Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KumaraswamyBK.png" project_subtitle="Kumarswamy BK"
                                    project_title="Shri Sa Associates"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/Vinod Tiwari.png" project_subtitle="Vinod Tiwari"
                                    project_title="Rashi Associates" linkk="https://www.youtube.com/watch?v=ZFA75G8gNng" vIds="ZFA75G8gNng"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/Venkatesh R.png" project_subtitle="Venkatesh R"
                                    project_title="Mindfin Ser Private Limited"></ProjectItem>

                                 <ProjectItem project_img_num="/south/NAGESH GOWDA.png" project_subtitle="Nagesh Gowda"
                                    project_title="S B S Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Thulasi Raman.png" project_subtitle="Thulasi Raman S"
                                    project_title="Thulasi Raman S"></ProjectItem>

                                 <ProjectItem project_img_num="/south/N Murali Krishnan AKM Financial solution.png" project_subtitle="N Murali Krishnan"
                                    project_title="AKM Financial Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/south/A BABU.png" project_subtitle="A Babu"
                                    project_title="BL Solution"></ProjectItem>

                                 <ProjectItem project_img_num="/south/C Soudararajan.png" project_subtitle="C Soundararajan"
                                    project_title="Capital Money Care"></ProjectItem>

                                 <ProjectItem project_img_num="/south/JAYAM NAGESH.png" project_subtitle="Jayam Nagesh"
                                    project_title="SRS Capital Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/DHARMENDAR SRIVASTAVA.png" project_subtitle="Dharmendar Srivastava"
                                    project_title="Finwizz Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/ABBURU SRIKANTH CHOUDHARY.png" project_subtitle="Abbura Srikanth Choudhary"
                                    project_title="Start Powerz Human Resources Private Limited" linkk="https://www.youtube.com/watch?v=mMe38Oxf16k" vIds="mMe38Oxf16k"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/THIRUPATHI RAO.png" project_subtitle="Thirupathi Rao"
                                    project_title="Finbud Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/SRINIVAS RAO VADDE.png" project_subtitle="Srinivas Rao Vadde"
                                    project_title="Sri Vamsi Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KIRAN KUMAR.png" project_subtitle="Kiran Kumar"
                                    project_title="Sri Sai Balaji Finserv"></ProjectItem>

                                 <ProjectItem project_img_num="/south/GIRIDHAR GOUD AKULA.png" project_subtitle="Giridhar Goud Akula"
                                    project_title="Sierras Strategic Solutions"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/SAI RAM RAJU.png" project_subtitle="Sai Ram Raju"
                                    project_title="Cconnect India" linkk="https://www.youtube.com/watch?v=9DrFdNcLaNk" vIds="9DrFdNcLaNk"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/MURALI KE DAS.png" project_subtitle="Murali Ke Das"
                                    project_title="Money Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/east/DSA Upender Lakshmi marketing.png" project_subtitle="Upender Kumar"
                                    project_title="Lakshmi Marketing, Jhamshedpur"></ProjectItem>

                                 <ProjectItem project_img_num="/east/MUKESH SINGH BALAJI FINCORP.png" project_subtitle="Mukesh Singh"
                                    project_title="Balaji Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/west/ALOK NAG.png" project_subtitle="Alok Nag"
                                    project_title="A and H Capital, Mumbai"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PIYUSH DOSHI.png" project_subtitle="Piyush Doshi"
                                    project_title="Andromeda Sales and Distribution Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PRANAY KOTHARI.png" project_subtitle="Pranay Kothari"
                                    project_title="OSM Capital Advisors Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SACHIN PORWAL.png" project_subtitle="Sachin Porwal"
                                    project_title="SIIA Advisory Consultants LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KHOZEMA TONKWALA.png" project_subtitle="Khozema Tonkwala"
                                    project_title="Trade Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PN SHETTY.png" project_subtitle="PN Shetty"
                                    project_title="Rupeeboss Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KAUSHIK MEHTA.png" project_subtitle="Kaushik Mehta"
                                    project_title="OSM Capital Advisors Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Amit Wani.png" project_subtitle="Amit Wani"
                                    project_title="SIIA Advisory Consultants LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/RAVI PARDESHI.png" project_subtitle="Ravi Pardeshi"
                                    project_title="R R Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/NITIN KHAIRE.png" project_subtitle="Nitin Khaire"
                                    project_title="True Way Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/dharmendra rajput.png" project_subtitle="Dharmendra Rajput"
                                    project_title="Dharmendra Rajput"></ProjectItem>

                                 <ProjectItem project_img_num="/west/piyush nagar.png" project_subtitle="Piyush Nagar"
                                    project_title="Mahir Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Birju Patel.png" project_subtitle="Birju Patel"
                                    project_title="Impetus Corporate Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/sanjay raiya.png" project_subtitle="Sanjay Raiya"
                                    project_title="Findesk Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/west/paresh gupta.png" project_subtitle="Paresh Gupta"
                                    project_title="Paresh Gupta"></ProjectItem>

                                 <ProjectItem project_img_num="/west/sachin survey.png" project_subtitle="Sachin Surve"
                                    project_title="Chetan Enterprise"></ProjectItem>


                              </div>
                           </div>

                           <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div className="row"> 

                                 <ProjectItem project_img_num="/north/Amit Arora.png" project_subtitle="Amit Arora"
                                    project_title="Chase Fly"></ProjectItem>                                 

                                 <ProjectItem project_img_num="/north/vk.jpeg" project_subtitle="Vaibhav Kulshreshta"
                                    project_title="My Mudra Fincorp Pvt Ltd, Delhi"></ProjectItem>

                                 <ProjectItem project_img_num="/north/cs.jpg" project_subtitle="Chetan Sethi"
                                    project_title="Dream Inc, Delhi"></ProjectItem>

                                 <ProjectItem project_img_num="/north/SidharthGupta.png" project_subtitle="Sidharth Gupta"
                                    project_title="S and I Enterprises, Delhi"></ProjectItem>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                              <div className="row">

                                 <ProjectItem project_img_num="/east/DSA Upender Lakshmi marketing.png" project_subtitle="Upender Kumar"
                                    project_title="Lakshmi Marketing, Jhamshedpur"></ProjectItem>

                                 <ProjectItem project_img_num="/east/MUKESH SINGH BALAJI FINCORP.png" project_subtitle="Mukesh Singh"
                                    project_title="Balaji Fincorp"></ProjectItem>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1">
                              <div className="row">

                                 <ProjectItem project_img_num="/south/TAPAN KUMAR OJHA.png" project_subtitle="Tapan Kumar Ojha"
                                    project_title="Finnest Tahera Financial Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KumaraswamyBK.png" project_subtitle="Kumarswamy BK"
                                    project_title="Shri Sa Associates"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/Vinod Tiwari.png" project_subtitle="Vinod Tiwari"
                                    project_title="Rashi Associates" linkk="https://www.youtube.com/watch?v=ZFA75G8gNng" vIds="ZFA75G8gNng"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/Venkatesh R.png" project_subtitle="Venkatesh R"
                                    project_title="Mindfin Ser Private Limited"></ProjectItem>

                                 <ProjectItem project_img_num="/south/NAGESH GOWDA.png" project_subtitle="Nagesh Gowda"
                                    project_title="S B S Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Thulasi Raman.png" project_subtitle="Thulasi Raman S"
                                    project_title="Thulasi Raman S"></ProjectItem>

                                 <ProjectItem project_img_num="/south/N Murali Krishnan AKM Financial solution.png" project_subtitle="N Murali Krishnan"
                                    project_title="AKM Financial Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/south/A BABU.png" project_subtitle="A Babu"
                                    project_title="BL Solution"></ProjectItem>

                                 <ProjectItem project_img_num="/south/C Soudararajan.png" project_subtitle="C Soundararajan"
                                    project_title="Capital Money Care"></ProjectItem>

                                 <ProjectItem project_img_num="/south/JAYAM NAGESH.png" project_subtitle="Jayam Nagesh"
                                    project_title="SRS Capital Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/DHARMENDAR SRIVASTAVA.png" project_subtitle="Dharmendar Srivastava"
                                    project_title="Finwizz Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/ABBURU SRIKANTH CHOUDHARY.png" project_subtitle="Abbura Srikanth Choudhary"
                                    project_title="Start Powerz Human Resources Private Limited" linkk="https://www.youtube.com/watch?v=mMe38Oxf16k" vIds="mMe38Oxf16k"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/THIRUPATHI RAO.png" project_subtitle="Thirupathi Rao"
                                    project_title="Finbud Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/south/SRINIVAS RAO VADDE.png" project_subtitle="Srinivas Rao Vadde"
                                    project_title="Sri Vamsi Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KIRAN KUMAR.png" project_subtitle="Kiran Kumar"
                                    project_title="Sri Sai Balaji Finserv"></ProjectItem>

                                 <ProjectItem project_img_num="/south/GIRIDHAR GOUD AKULA.png" project_subtitle="Giridhar Goud Akula"
                                    project_title="Sierras Strategic Solutions"></ProjectItem>

                                  <ProjectItem1 project_img_num="/south/SAI RAM RAJU.png" project_subtitle="Sai Ram Raju"
                                    project_title="Cconnect India" linkk="https://www.youtube.com/watch?v=9DrFdNcLaNk" vIds="9DrFdNcLaNk"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/MURALI KE DAS.png" project_subtitle="Murali Ke Das"
                                    project_title="Money Fincorp"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact2" role="tabpanel" aria-labelledby="contact-tab2">
                              <div className="row">

                                 <ProjectItem project_img_num="/west/ALOK NAG.png" project_subtitle="Alok Nag"
                                    project_title="A and H Capital, Mumbai"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PIYUSH DOSHI.png" project_subtitle="Piyush Doshi"
                                    project_title="Andromeda Sales and Distribution Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PRANAY KOTHARI.png" project_subtitle="Pranay Kothari"
                                    project_title="OSM Capital Advisors Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SACHIN PORWAL.png" project_subtitle="Sachin Porwal"
                                    project_title="SIIA Advisory Consultants LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KHOZEMA TONKWALA.png" project_subtitle="Khozema Tonkwala"
                                    project_title="Trade Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/west/PN SHETTY.png" project_subtitle="PN Shetty"
                                    project_title="Rupeeboss Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KAUSHIK MEHTA.png" project_subtitle="Kaushik Mehta"
                                    project_title="OSM Capital Advisors Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Amit Wani.png" project_subtitle="Amit Wani"
                                    project_title="SIIA Advisory Consultants LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/RAVI PARDESHI.png" project_subtitle="Ravi Pardeshi"
                                    project_title="R R Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/NITIN KHAIRE.png" project_subtitle="Nitin Khaire"
                                    project_title="True Way Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/dharmendra rajput.png" project_subtitle="Dharmendra Rajput"
                                    project_title="Dharmendra Rajput"></ProjectItem>

                                 <ProjectItem project_img_num="/west/piyush nagar.png" project_subtitle="Piyush Nagar"
                                    project_title="Mahir Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Birju Patel.png" project_subtitle="Birju Patel"
                                    project_title="Impetus Corporate Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/sanjay raiya.png" project_subtitle="Sanjay Raiya"
                                    project_title="Findesk Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/west/paresh gupta.png" project_subtitle="Paresh Gupta"
                                    project_title="Paresh Gupta"></ProjectItem>

                                 <ProjectItem project_img_num="/west/sachin survey.png" project_subtitle="Sachin Surve"
                                    project_title="Chetan Enterprise"></ProjectItem>

                              </div>
                           </div>                           

                        </div>
                     </div>
                  </div>
               </div>
               
               {/* <div className="row">
                  <div className="col-12">
                     <div className="tp-projects-btn d-flex justify-content-center">
                        <Link to="/projectsDetails" className="theme-btn text-white">
                           <i className="flaticon-enter"></i> Explore More</Link>
                     </div>
                  </div>
               </div> */}

            </div>
         </div>
      </>
   );
};

export default ProjectsArea;